import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const PageViewTracker = () => {
  const location = useLocation();
  const posthog = usePostHog();

  // biome-ignore lint/correctness/useExhaustiveDependencies: location is the trigger, one page view per navigation
  useEffect(() => {
    if (posthog) {
      posthog.capture('$pageview');
    }
  }, [location, posthog]);

  return <></>;
};
